<template>
    <div>
        <div class="container-new right-info-block" style="text-align: center;">
            <div class="order-instruction-header mb-10">
                <i class="ion-android-locate header-icon"></i>
                <h2>Wybrany punkt podjęcia</h2>

            </div>
            <div id="first-step-map" style="height: 290px;">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'firstStepMap',
        props: ['coord'],
        data () {
            return {
                map: null
            }
        },

        mounted: function() {
            console.log('moubnt - sdffd');
            var self = this;
            this.initMap();

            Event.$on('setDivision', function(custLocation) {
                console.log('mapSetCustomLocation');
                if (custLocation) {
                    self.addMarker(custLocation.Lat, custLocation.Lng, "");
                    self.map.panTo( new google.maps.LatLng(custLocation.Lat, custLocation.Lng));
                }

            });
        },

        methods: {
            addMarker: function (lat, lng, label) {
                var coordinate = new google.maps.LatLng(lat, lng);
                var marker = new google.maps.Marker({
                    position: coordinate,
                    map: this.map,
                    title: '' + label
                });
                // If you don't specify a Map during the initialization //of the Marker you can add it later using the line //below
                marker.setMap(this.map);

            },

            initMap: function () {
                google.maps.visualRefresh = true;
                var centerPoint = [52.229676,  21.012229];
                var zoomLevel = 10;
                this.map = new google.maps.Map(document.getElementById('first-step-map'), {
                    center: {lat: centerPoint[0], lng: centerPoint[1]},
                    scrollwheel: false,
                    disableDefaultUI: true,
                    scaleControl: false,
                    mapTypeControl: false,
                    zoom: zoomLevel
                })

            }
        }
    }
</script>



// WEBPACK FOOTER //
// FirstStepMap.vue?d40d2f88